// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  appVersion: '1.0.9',
  apiVersion: 'v1.0',
  apiUrl: 'https://dev.myvetbusiness.it/',
  appUrl: 'https://dev.app.myvet.it',

  dietUrl: 'https://myvetdiet.com/',

  blogApiUrl: 'https://api.myvet.it/',

  posthog: {
    key: "phc_u53NFClkpVZG3N5zmDssuaVg9pyxZAoOpY3pH2HNLv1",
    host: "https://hog.myvetbusiness.it",
  },

  firebase: {
    apiKey: 'AIzaSyDMKpXwkjHIezKy5ae2bUi_AUb46fcNQao',
    authDomain: 'myvet-383716.firebaseapp.com',
    projectId: 'myvet-383716',
    storageBucket: 'myvet-383716.appspot.com',
    messagingSenderId: '48835804057',
    appId: '1:48835804057:web:228de82963aec643b37108',
    vapidKey:
      'BO-hrtEMm3QrvLwlbdgnUE1haSYql1O_TtaQS8sbaiMCZk7Ea-4BBhn8AP0u0oJIejxShBgs7zNbXSy-7i-Utc4',
  },

  // revenuecat
  apiKeyIOS: 'appl_rGOAZNFwgJDOZTCFqUlGDyzEDPc',
  apiKeyAndroid: 'goog_dpYlpWVfwgjTxbCJikOYaTQECSy',

  mapbox: {
    endPoint: 'https://api.mapbox.com',
    accessToken:
      'pk.eyJ1IjoibXl2ZXQiLCJhIjoiY2xxeGxweW11MGZ4ajJrbWl5NXlmNnFxYSJ9.DsT2-nvBFrLh2s52Mwp0zQ',
  },

  google: {
    webClientId:
      '48835804057-9r71n8r83cdfn1vliim10efs78o0bibk.apps.googleusercontent.com',
    // Deve corrispondere allo scheme invertito in ios/App/App/Info.plist.
    iosClientId:
      '48835804057-f0vfgeoreferhl9ahln7ol77acg072ed.apps.googleusercontent.com',
    // Usato solo dal web: il popup OAuth torna qui, e questo indirizzo deve
    // stare tra i redirect URI del client, scritto identico. Su native è ignorato.
    // 8100 è la porta di `ionic serve`.
    redirectUrl: 'http://localhost:8100/',
  },

  stripe: {
    pet_diet: {
      publicKey:
        'pk_test_51TFAOPAN70r8NzRWGFe86t90vLlRJrkGmuGdgZHNfIiGYmyRKXZMr7q4sGa2brCoK9znwme6iojBwpnZ084Q0EqR00KOO35e9D',
    },
    sos: {
      publicKey: 
        'pk_test_51TFAOIPFklK8IQWc9f1p4GwyL4CTfJ5Sct9pBtlhwml0T41Y2ayTCh9vY9QCH4lL60lxzjNXJX7ca6fgC6ZmwaSG00R61wFUV4',
    },
  },

  dogID: '2'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
